import React from 'react';
import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { useBreakpointsMediaUp } from '@nubank/nuds-web/styles/breakpoints';

import useFigPiiExperiment from '@nubank/www-latam-commons/utils/figpii/useFigPiiExperiment';

import { MGM_CTA_EXPERIMENT_ID, MGM_CTA_PURPLE_EXPERIMENT_VARIANT } from '../../../../utils/experiments';

const StyledTypography = styled(Typography)`
  background: linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%);
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
`;

const Divider = () => {
  const isDesktop = useBreakpointsMediaUp('md');

  // CTA Experiment
  const ctaExperimentVariant = useFigPiiExperiment(MGM_CTA_EXPERIMENT_ID);
  const isCTAPurpleActive = ctaExperimentVariant === MGM_CTA_PURPLE_EXPERIMENT_VARIANT;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      marginBottom={{ xs: isCTAPurpleActive ? '8x' : '16x', md: '16x' }}
      marginTop={{ xs: isCTAPurpleActive ? '12x' : '0x', lg: isCTAPurpleActive ? '24x' : '0x' }}
    >
      <Typography
        intlKey="MGM.DIVIDER.TITLE"
        variant={isDesktop ? 'heading3' : 'heading2'}
        textAlign="center"
      />
      <StyledTypography
        intlKey="MGM.DIVIDER.HIGHLIGHT"
        variant={isDesktop ? 'heading3' : 'heading2'}
        textAlign="center"
        marginBottom={{ xs: '2x', lg: '8x' }}
      />
    </Box>
  );
};

export default Divider;
